<script>
  import options from './PostHeaderAddComment.options'
  export default options
</script>

<template>
  
    <article class="kb-component--post-header-add-comment kb-post-header-add-comment kb-stafet-step" id="postHeaderAddComment">

        <hr class="kb-stafet-step__breaker-line" />
        <h2 class="kb-post-header-add-comment__title">{{ getLabel('createCommentLabel') }}</h2>
        <div class="kb-post-comment__new-comment-editor">
            <editor api-key="no-api-key" :init='{
                    plugins: "emoticons autoresize lists autolink",
                    toolbar: "emoticons bold italic underline bullist numlist",
                    toolbar_location: "bottom",
                    menubar: false,
                    statusbar: false,
                    license_key: "gpl"
                }'
                v-model="newCommentContent"></editor>
        </div>
        
        <AttachmentsEditor
            :files="[]"
            @update:filesToAdd="$event => newCommentFilesToAdd = $event"
        />

        <button 
            v-on:click="submitNewComment" 
            class="kb-button kb-button--full-color-spot"
            :class="{
                'kb-button--disabled': isSubmitButtonDisabled
            }">
            {{ getLabel('submitCommentCtaLabel') }}
        </button>

    </article>

</template>